import styled, { css } from 'styled-components';

import BootstrapNav from 'react-bootstrap/Nav';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import BootstrapNavDropdown from 'react-bootstrap/NavDropdown';
import theme from '../../styles/theme';

export const Navbar = styled(BootstrapNavbar)`
  background-color: ${theme.colors.dark_blue};
  z-index: 10;
`;

export const NavLink = styled(BootstrapNav.Link)`
  text-transform: uppercase;
  font-size: 13px;
  border-radius: 5px;
  color: ${theme.colors.white};
  padding: 0.5rem 1rem;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: ${theme.colors.white};
    text-decoration: none;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: rgba(255, 255, 255, 0.15);
    `}

  @media (max-width: 768px) {
    padding: 1rem 1rem;
  }
`;

export const NavDropdown = styled(BootstrapNavDropdown)`
  > a {
    text-transform: uppercase;
    font-size: 13px;
    border-radius: 5px;
    color: ${theme.colors.white} !important;
    transition: background ease-in 0.3s;
    ${({ active }) =>
      active &&
      css`
        background-color: rgba(255, 255, 255, 0.15);
      `}
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      color: ${theme.colors.white};
    }

    @media (max-width: 768px) {
      padding: 1rem;
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .dropdown-menu {
    padding: 0;
    max-height: calc(100vh - 40px - 40px);
    overflow-y: auto;
    > a {
      text-transform: uppercase;
      font-size: 13px;
      padding: 0.5rem 1rem;

      &:hover {
        border-radius: 5px;
      }
    }
  }
`;

// export const NavItem = styled(BootstrapNav.Item)`
//   > a {
//     border-radius: 5px;
//     color: ${theme.colors.white};
//     transition: background ease-in 0.3s;
//     line-height: normal;
//     text-transform: uppercase;

//     &:hover {
//       background-color: rgba(255, 255, 255, 0.15);
//       color: ${theme.colors.white};
//     }

//     ${({ active }) =>
//       active &&
//       css`
//         background-color: rgba(255, 255, 255, 0.15);
//       `}
//   }
// `;

// export const NavDropdown = styled(BootstrapNavDropdown)`
//   > a {
//     border-radius: 5px;
//     color: ${theme.colors.white};
//     transition: background ease-in 0.3s;
//     ${({ active }) =>
//       active &&
//       css`
//         background-color: rgba(255, 255, 255, 0.15);
//       `}
//     &:hover {
//       background-color: rgba(255, 255, 255, 0.15);
//       color: ${theme.colors.white};
//     }
//   }
// `;

export const NotificationUnreadIcon = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: ${theme.colors.error};
  position: absolute;
  top: 10px;
  left: 25px;
`;
